// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarRatingField_stars__1HJNE"};